import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import AddBrand from '../../core/modals/inventory/addbrand';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import { ChevronUp, PlusCircle } from 'feather-icons-react/build/IconComponents';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { setToogleHeader } from '../../core/redux/action';
import withReactContent from 'sweetalert2-react-content';
import { useToast } from '../../Toaster/ToastContext';
import Loader from '../loader/loader';
import { apiClient } from '../../services/apiClient';

const BrandList = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentBrand, setCurrentBrand] = useState(null);
    const { showToast } = useToast();
    const hasFetched = useRef(false);
    const [permissions, setPermissions] = useState({
        create: false,
        read: false,
        update: false,
        delete: false,
    });

    useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
        try {
            const Permissions = JSON.parse(storedPermissions);
            const getPermissions = JSON.parse(Permissions.permissions)
            if(getPermissions.permissions){
                parsedPermissions = getPermissions.permissions;
            }
            else {
                parsedPermissions = getPermissions;
            }
        
            const inventoryPermissions = parsedPermissions.find(
                (item) => item.title === "Inventory"
            );

            const productPermissions = inventoryPermissions?.childPage?.find(
                (child) => child.title === "Brands"
            );
            // console.log("search product", productPermissions)

            if (productPermissions) {
                setPermissions({
                    create: productPermissions.create || false,
                    read: productPermissions.read || false,
                    update: productPermissions.update || false,
                    delete: productPermissions.delete || false,
                });
            } else {
                console.error("Product permissions not found in localStorage");
                showToast("Product permissions not found.", "error", "Permissions Error");
            }
        } catch (error) {
            console.error("Error parsing permissions from localStorage:", error);
            showToast("Failed to load permissions.", "error", "Permissions Error");
        }
    }, []);

    const fetchBrands = async (force = false) => {
        if (hasFetched.current && !force) return;
        setLoading(true);
        try {
            const response = await apiClient.post('/paginate-brand', {
                pageIndex: 0,
                pageSize: 50,
                previousPageIndex: 0,
            })
            const data = await response;
            if (data.success) {
                setBrands(data.data);
                setFilteredBrands(data.data);
            } else {
                setBrands([]);
                setFilteredBrands([]);
            }
        } catch (error) {
            showToast(error.message || 'Failed to fetch categories', 'error', 'Brands');
        } finally {
            setLoading(false);
            hasFetched.current = true;
        }
    };

    useEffect(() => {
        fetchBrands();
    }, []);

    const handleAddBrand = () => {
        setCurrentBrand(null);
    };

    const handleEditBrand = (brand) => {
        setCurrentBrand(brand);
    };

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setFilteredBrands(
            brands.filter((brand) =>
                brand.name.toLowerCase().includes(term) ||
                brand.status.toLowerCase().includes(term)
            )
        );
    };

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )

    const columns = [

        {
            title: "Brand",
            dataIndex: "name",
            sorter: (a, b) => a.name.length - b.name.length,
        },

        {
            title: "Logo",
            dataIndex: "brand_image",
            render: (text, record) => (
                <span className="productimgname">
                    <Link to="#" className="product-img stock-img">
                        <ImageWithBasePath alt={record.name || "Brand Logo"} src={record.brand_image || "assets/img/product/product1.jpg"} />
                    </Link>
                </span>
            ),
            sorter: (a, b) => a.brand_image.length - b.brand_image.length,
            width: "5%"
        },
        {
            title: "Created On",
            dataIndex: "created_at",
            sorter: (a, b) => a.created_at.length - b.created_at.length,
            render: (text) => {
                const date = new Date(text);
                return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).split('/').join('-');
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span className={`badge ${text === 'Active' ? 'badge-linesuccess' : 'badge-linedanger'}`}>
                    {text === 'Active' ? 'Active' : 'Inactive'}
                </span>
            ),
            sorter: (a, b) => a.status.length - b.status.length,
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (_, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        {permissions.read && (
                            <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-brand"  onClick={() => handleEditBrand(record)}>
                                <i data-feather="edit" className="feather-edit"></i>
                            </Link>
                        )}
                        {permissions.delete && (
                            <Link className="confirm-text p-2" to="#"  >
                                <i data-feather="trash-2" className="feather-trash-2" onClick={() => showConfirmationAlert(record)}></i>
                            </Link>
                        )}
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#ff0000',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    const response = await apiClient.post('/delete-brand', {
                        id: record.id,
                    })
                    const data = await response;
                    if (data.success) {
                        showToast('Brand deleted successfully', 'success', 'Brand Operation!');
                        fetchBrands(true);
                    } else {
                        showToast(data.message || 'Failed to delete brand', 'error', 'Brand Operation!');
                    }
                } catch (error) {
                    showToast(error.message || 'Failed to delete brand', 'error', 'Brand Operation!');
                } finally {
                    setLoading(false);
                }
            } else {
                MySwal.close();
            }
        });
    };

    return (
        <div>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Brand</h4>
                                <h6>Manage your brands</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className="page-btn">
                            {permissions.create && (
                                <Link
                                    to="#"
                                    className="btn btn-added"
                                    data-bs-toggle="modal"
                                    data-bs-target="#add-brand"
                                    onClick={handleAddBrand}
                                >
                                    <PlusCircle className="me-2" />
                                    Add New Brand
                                </Link>
                            )}
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            onChange={handleSearch}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={filteredBrands}
                                    rowKey={(record) => record.id}
                                    rowSelection={null}
                                />
                            </div>
                        </div>
                        {/* /product list */}
                    </div>
                </div>
            </div>
            <AddBrand
                brand={currentBrand}
                onSave={() => {
                    hasFetched.current = false;
                    fetchBrands();
                }}
            />
        </div>
    )
}

export default BrandList;
